<style lang="less">
.confirm {
	width: 35% !important;

	p {
		overflow: initial;
		white-space: initial !important;
	}
}
</style>
<style scoped lang="less">
/deep/ .el-empty {
	background-color: #fff;
	margin: 1rem 0;
}

/* 设置持续时间和动画函数 */
.v-enter-active,
.v-leave-active {
	transition: all 0.8s ease;
}

.v-enter,
.v-leave-to {
	transform: translateY(-100px);
	opacity: 0;
}

.contentbox {
	width: 100%;
	margin: 1rem 0;

	ul {
		// background-color: #f5f5f5;
		overflow: hidden;
		margin: 20px 0;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;

		@media (min-width: 992px) {
			.col-lg-3 {
				-webkit-box-flex: 0;
				-ms-flex: 0 0 auto;
				flex: 0 0 auto;
				width: 24% !important;
			}

			li:last-child:nth-child(4n + 2) {
				// background-color: orange;
				margin-right: calc((100% - 24%) / 3 * 2);
			}

			li:last-child:nth-child(4n + 3) {
				// background-color: pink;
				margin-right: calc((100% - 24%) / 3 * 1);
			}
		}

		li {
			box-sizing: border-box;
			background: #fff;
			border-radius: 2px;
			margin: 1rem 0;
			position: relative;
			margin: 1rem 0;
			box-shadow: 2px 6px 10px 0;
			overflow: hidden;

			.titimes {
				font-size: 0.8rem;
				color: #333;
				margin: 1rem 0 0.5rem 0.5rem;
				font-weight: 700;
				overflow: hidden;
				text-overflow: ellipsis;
			}

			img {
				width: 100%;
				height: 16rem;
				object-fit: cover;
				transition: 0.8s;
			}

			#zzc {
				width: 100%;
				height: 16rem;
				background: rgba(0, 0, 0, 0.4);
				position: absolute;
				top: 0;
				display: none;
				cursor: pointer;
				line-height: 16rem;
				text-align: center;

				span {
					font-size: 3vw;
					color: #faad39;
					margin: 1rem 0;
				}

				span:first-child {
					// margin-top: 0 !important;
					margin: 0;
				}
			}

			.contentc {
				display: inline-block;
				// width: 100%;
				margin: 0 0.5rem;
				overflow: hidden;
				text-overflow: ellipsis;
				// text-indent: 3em;
				/* 超出部分省略号 */
				word-break: break-all;
				/* break-all(允许在单词内换行。) */
				display: -webkit-box;
				/** 对象作为伸缩盒子模型显示 **/
				-webkit-box-orient: vertical;
				/** 设置或检索伸缩盒对象的子元素的排列方式 **/
				-webkit-line-clamp: 3;
				/** 显示的行数 **/
			}

			button:hover {
				color: #fff !important;
				background: #1caf9a;
			}

			.roomsbutton {
				text-align: left;
				width: 95%;
				border-radius: 10px;
				margin: 1rem 0.6rem;
				display: flex;
				align-items: center;
				justify-content: space-between;

				.changeox {
					// margin-right: 1rem;
					width: 1rem;

					input[type='checkbox'] {
						width: 100%;
						height: 1.4em;
						background-color: #dcdce3;
						border: 1px solid #ccc;
					}

					input[type='checkbox']:checked {
						background-color: #003e6d;
					}
				}

				span {
					margin-left: 5px;
				}

				button {
					padding: 0.6rem 0.8rem;
					border: 1px solid #ccc;
					border-radius: 5px;
					color: #999999;
					translate: all 2s;
				}
			}
		}
	}
}

.elpagian {
	display: flex;
	align-items: center;
	justify-content: center;

	.el-pagination {
		border: 1px solid transparent;
		padding: 0.4rem 1rem;
		border-radius: 4rem;
		background-color: #fff;
		box-shadow: 0 0px 10px 0;
	}
}

.deletrains {
	border: 1px solid;
	border-radius: 5rem;
	position: fixed;
	top: 20%;
	padding: 0 1rem;
	background-color: red;
	color: #fff;
	left: 56%;
	font-size: 1vw;
	// transform: translateX(%);
}
</style>
<template>
	<div>
		<titles titlename="实训室管理" titlecontent="实训室的管理" :mbx="paths"></titles>
		<filters :rooms="filterslist"></filters>
		<div class="contentbox">
			<el-empty v-if="roomlist.length == 0" description="暂无实训室"></el-empty>
			<ul>
				<li
					class="col-xs-12 col-sm-5 col-md-5 col-lg-3"
					v-for="(item, index) in roomlist"
					:key="index"
					@mouseenter="changeeyes($event)"
					@mouseleave="changeeyelieve($event)"
				>
					<div style="overflow: hidden;" @click.stop="gorooms(index, item.roomnames, item)">
						<!-- <img :src="item.img==''?'./../../images/roomimg.png':item.img" alt=""> -->
						<img v-if="item.img == ''" src="./../../images/trainroomsl.png" alt="" />
						<img v-if="item.img !== ''" :src="item.img" alt="" />
					</div>
					<div id="zzc">
						<div style="margin-top: 3.5vw; display: flex;flex-direction: column;align-items: center;justify-content: center;">
							<span v-if="item.islooking == 1" @click.stop="gorooms(index, item.roomnames, item)" class="fas fa-eye"></span>
							<!-- <span @click.stop="alldelect(item)" class="el-icon-s-unfold" style="color: #afafaf;"></span> -->
							<span v-if="item.istraindelct == 1" @click.stop="delect(item)" class="el-icon-delete-solid" style="color: #d14141;"></span>
						</div>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;padding: 0 0.4rem;">
						<p class="titimes" style="margin-right: 1rem;">
							<!-- {{item.SchoolInfo.si_name_cn}} -->
							{{ item.schoolName }}
						</p>
						<p class="titimes">{{ item.tr_name }}</p>
					</div>

					<span class="contentc">{{ item.tr_introduction }}</span>
					<div class="roomsbutton">
						<button v-if="item.islooking == 1" @click="gorooms(index, item.roomnames, item)">
							查看更多
							<span>></span>
						</button>
						<div class="changeox" title="勾选可以删除" v-if="item.istraindelcts == 1"><input type="checkbox" @click="choicetrain($event, item, index)" /></div>
					</div>
				</li>
			</ul>
		</div>

		<div class="elpagian">
			<el-pagination @current-change="handleCurrentChange" background layout="prev, pager, next" :page-size="pagesize" :total="pageNumber"></el-pagination>
		</div>

		<!-- <transition>
			<div v-if="delecta==1" class="deletrains" @click="alldelect()">
				批量删除
			</div>
		</transition> -->
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';
import filters from '@/components/filters/filterstrain.vue';
import { getTrainRoom, getdgPageTrainDelete, TrainDeleteList } from '@/request/api/trainroom/trainroom.js';
import { GetbjGetSchoolList } from '@/request/api/mange/mange.js';
import $ from 'jquery';

import AppOptions from '@/config/AppOptions.vue';

export default {
	data() {
		return {
			delecta: 0,
			// 批量删除
			checklist: [],
			checked: 0,
			// 实训室内容
			roomlist: [],
			// 标题组件
			paths: [
				{
					path: '/allmanage',
					name: '实训管理'
				},
				{
					path: '/allmanage/trainingmange',
					name: '实训室管理'
				}
			],
			// 筛选组件
			pageNumber: 0,
			paganum: 1,
			pagesize: 8,
			schoollist: [],
			filterslist: {
				name: '实训室',
				content: '',
				filterlist: [
					{
						id: 0,
						indexsshol: 0,
						title: '所属院校',
						childers: []
					}
				]
			},
			schoolsiguid: '',
			// 动态权限指令
			powershowobj: {}
		};
	},
	watch: {
		roomlist(val) {
			// console.log(val,"长度变化")
			this.roomlist = val;
		}
	},
	created() {
		AppOptions.appEmpty = false;
		let powerlist = JSON.parse(window.sessionStorage.getItem('allbtnlist'));
		// console.log('cookie列表无效',powerlist)

		this.powershowobj.powershows = powerlist;
		this.powershowobj.routers = this.$route.path;
	},
	beforeMount() {},
	mounted() {
		this.getscool();
	},
	updated() {},
	methods: {
		changeschoolif(id) {
			this.schoolsiguid = id;
			this.getTrainRoom();
		},

		getscool() {
			let allobj = {
				si_name_cn: '全部',
				shoolid: 0,
				si_guid: ''
			};
			GetbjGetSchoolList().then(res => {
				// console.log(res, "院校不分页")
				this.schoollist = JSON.parse(JSON.stringify(res.data.data));
				if (this.schoollist.length == 1) {
					allobj.si_guid = this.schoollist[0].si_guid;
					this.schoolsiguid = this.schoollist[0].si_guid;
					this.getTrainRoom();
					// console.log(this.roomlist.length,"长度")
				} else {
					this.schoolsiguid = '';
					this.getTrainRoom();
					this.schoollist.unshift(allobj);
				}

				this.schoollist.forEach(item => {
					item.name = item.si_name_cn;
				});

				this.filterslist.filterlist[0].childers = this.schoollist;
			});
		},
		// 点击选择
		choicetrain(e, itm, idx) {
			if (e.target.checked == true) {
				//当判断复选框被选中时，可以做一些处理事件
				this.checklist.push(itm.sx_tr_guid);
				this.delecta = 1;
			} else {
				// console.log("未选中")
				// console.log(this.checklist.indexOf(itm.sx_tr_guid))
				if (this.checklist.indexOf(itm.sx_tr_guid) != -1) {
					let num = this.checklist.indexOf(itm.sx_tr_guid);
					this.checklist.splice(num, 1);
				}
				if (this.checklist.length == 0) {
					this.delecta = 0;
				}
			}
			// console.log(this.checklist, "批量删除数组")
		},
		// 批量删除与删除
		alldelect() {
			// console.log("批量删除")
			if (this.checklist.length > 0) {
				let traindelobj = {
					sx_tr_guid: this.checklist,
					isdelete: 'false'
				};
				this.$confirm('确定删除选中的记录吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
					.then(() => {
						TrainDeleteList(traindelobj).then(res => {
							// console.log(res, "批量删除")
							if (res.data.code == 1) {
								this.$message({
									message: '恭喜你，' + res.data.msg,
									type: 'success'
								});
								this.getTrainRoom();
								this.delecta = 0;
							} else {
								this.$confirm(res.data.msg + `<div style='color:red;'>当前记录删除后会删除关联数据且不能恢复，请谨慎选择</div>`, '提示', {
									confirmButtonText: '点击确定',
									cancelButtonText: '取消',
									type: 'warning',
									customClass: 'confirm',
									dangerouslyUseHTMLString: true
								})
									.then(() => {
										traindelobj = {
											sx_tr_guid: this.checklist,
											isdelete: 'true'
										};
										TrainDeleteList(traindelobj).then(res => {
											// console.log(res)
											if (res.data.code == 1) {
												this.$message({
													message: '恭喜你，' + res.data.msg,
													type: 'success'
												});
												this.delecta = 0;
												this.getTrainRoom();
											}
										});
									})
									.catch(() => {
										// console.log("有记录取消删除")
									});
							}
						});
					})
					.catch(() => {
						this.$message({
							type: 'info',
							message: '已取消删除'
						});
					});
			} else {
				this.$message({
					type: 'info',
					message: '请选择删除实训室'
				});
			}
		},
		delect(item) {
			this.$confirm('确定删除这条记录吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					let traindelobj = {
						sx_tr_guid: item.sx_tr_guid,
						isDelete: false
					};

					getdgPageTrainDelete(traindelobj).then(res => {
						// console.log(res)
						if (res.data.code == 1) {
							this.$message({
								message: '恭喜你，' + res.data.msg,
								type: 'success'
							});
							this.getTrainRoom();
						} else {
							this.$confirm(res.data.msg + `<div style='color:red;'>当前记录删除后会删除关联数据且不能恢复，请谨慎选择</div>`, '提示', {
								confirmButtonText: '点击确定',
								cancelButtonText: '取消',
								type: 'warning',
								customClass: 'confirm',
								dangerouslyUseHTMLString: true
							})
								.then(() => {
									traindelobj = {
										sx_tr_guid: item.sx_tr_guid,
										isDelete: true
									};
									getdgPageTrainDelete(traindelobj).then(res => {
										console.log(res);
										if (res.data.code == 1) {
											this.$message({
												message: '恭喜你，' + res.data.msg,
												type: 'success'
											});
											this.getTrainRoom();
										}
									});
								})
								.catch(() => {
									console.log('有记录取消删除');
								});
						}
					});
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			// console.log("删除")
		},

		// 分页
		handleCurrentChange(val) {
			this.paganum = val;
			this.getTrainRoom();
		},

		getTrainRoom(trname = null) {
			var TrainRoom = {
				nums: this.paganum,
				size: this.pagesize,
				tr_name: trname == null ? '' : trname,
				si_guid: this.schoolsiguid
			};
			getTrainRoom(TrainRoom).then(res => {
				// console.log(res.data.data,"实训室")
				this.pageNumber = res.data.data.totalCount;

				// console.log(this.pageNumber,'总数')

				this.roomlist = res.data.data.list;
				this.roomlist.forEach((item, index) => {
					if (item.PicList.length > 0) {
						item.img = item.PicList[0].sx_tp_imgPath;
					} else {
						item.img = '';
					}
					item.islooking = 0;
					item.istraindelct = 0;
					item.istraindelcts = 0;
					// console.log(item.SchoolInfo.si_name_cn,index,"学校名称")
					// if(item.SchoolInfo.si_name_cn){
					// 	item.schoolName = item.SchoolInfo.si_name_cn
					// }
				});
				for (let i = 0; i < this.roomlist.length; i++) {
					// console.log(this.roomlist[i].SchoolInfo)
					let schoolinfo = this.roomlist[i].SchoolInfo;
					if (schoolinfo) {
						this.roomlist[i].schoolName = schoolinfo.si_name_cn;
					}
				}
				// console.log(this.powershowobj.powershows,'这里可以查看')

				this.powershowobj.powershows.forEach(item => {
					// console.log(item.path == this.$route.path , item.title == '查看')
					if (item.path == this.$route.path && item.title == '查看') {
						this.roomlist.forEach(ite => {
							ite.islooking = 1;
						});
						// console.log("有查看可以看")
					}
					if (item.path == this.$route.path && item.title == '删除') {
						this.roomlist.forEach(ite => {
							ite.istraindelct = 1;
						});
						// console.log("有删除可以看")
					}

					if (item.path == this.$route.path && item.title == '批量删除') {
						this.roomlist.forEach(ite => {
							ite.istraindelcts = 1;
						});
						// console.log("有批量删除可以看")
					}
				});

				// console.log(this.roomlist.length,"实训室")
			});
		},
		gorooms(i, e, item) {
			this.powershowobj.powershows.forEach(items => {
				if (items.path == this.$route.path && items.title == '查看') {
					this.$router.push({
						path: '/device/roomxq?id=' + i + '&name=实训室&schoolid=' + item.sx_tr_guid
					});
				}
			});
		},
		changeeyes(e) {
			let doms = e.target;
			// console.log(doms.querySelector("#zzc"))
			doms.querySelector('#zzc').style.display = 'block';
			doms.querySelector('img').style.transform = 'scale(1.2)';
		},
		changeeyelieve(e) {
			// console.log(e.target)
			let domes = e.target;
			domes.querySelector('#zzc').style.display = 'none';
			domes.querySelector('img').style.transform = 'scale(1)';
		}
	},
	components: {
		titles,
		filters
	}
};
</script>
